// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__E2lOg","modalFooter":"style__modalFooter__Jo86C"};